export default __webpack_public_path__ + "static/media/DNo.24-5.0fe3c15f.jpg";